import React, { useLayoutEffect, useState } from "react";
import naocarenagrada from "../assets/naocarenagrada.png";
import naocalenagrada from "../assets/naocalenagrada.png";
import novaigra from "../assets/novaigra.png";
import novaigradown from "../assets/novaigradown.png";
import pokusajponovo from "../assets/pokusajponovo.png";
import ringnagrada from "../assets/ringnagrada.png";
import ocalanagrada from "../assets/ocalanagrada.png";
import stojalonagrada from "../assets/stojalonagrada.png";
import poskusiponovo from "../assets/poskusiponovo.png";

import style from "./Screen04.module.css";

const Screen04 = ({
  phase,
  setPhase,
  language,
  setLanguage,
  award,
  setAward,
}) => {
  const [res, setRes] = useState(ocalanagrada);
  const [resStyle, setResStyle] = useState(style.result);
  const [newGame, setNewGame] = useState(novaigra);
  const [newGameStyle, setNewGameStyle] = useState(style.newGame);

  const handlePointerDown = () => {
    setNewGame(novaigradown);
    setNewGameStyle(style.newGameDown);
  };
  const handlePointerLeave = () => {
    setNewGame(novaigra);
    setNewGameStyle(style.newGame);
  };
  const handlePointerUp = () => {
    setPhase(1);
  };

  useLayoutEffect(() => {
    if (award === "glasses") {
      if (language === "Croatia" || language === "Bosnia") {
        setRes(naocalenagrada);
        setResStyle(style.result);
      }
      if (language === "Serbia" || language === "Montenegro") {
        setRes(naocarenagrada);
        setResStyle(style.result);
      }
      if (language === "Slovenia") {
        setRes(ocalanagrada);
        setResStyle(style.resultSlo1);
      }
    }
    if (award === "ring") {
      if (
        language === "Croatia" ||
        language === "Bosnia" ||
        language === "Montenegro" ||
        language === "Serbia"
      ) {
        setRes(ringnagrada);
        setResStyle(style.result);
      }
      if (language === "Slovenia") {
        setRes(stojalonagrada);
        setResStyle(style.resultSlo2);
      }
    }
    if (award === "nista") {
      if (
        language === "Croatia" ||
        language === "Bosnia" ||
        language === "Montenegro" ||
        language === "Serbia"
      ) {
        setRes(pokusajponovo);
        setResStyle(style.result);
      }
      if (language === "Slovenia") {
        setRes(poskusiponovo);
        setResStyle(style.resultSlo3);
      }
    }
  }, [award, language]);
  return (
    <div className={style.screen04}>
      <img src={res} className={resStyle} alt="result" />
      <img
        src={newGame}
        className={newGameStyle}
        onPointerDown={handlePointerDown}
        onPointerLeave={handlePointerLeave}
        onPointerUp={handlePointerUp}
        alt="award"
      />
    </div>
  );
};

export default Screen04;
